@import 'abstract/variables';
@import 'abstract/colors';
@import 'buttons';


back-to-stock {
  width: 100%;
  margin: auto 0 0;

  .btn-orange,
  .btn-orange-stroke {
    &.btn-notify {
      height: 46px;
      display: flex;
      margin: 0 17px;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      width: 318px;

      @include breakpoint(sm) {
        width: auto;
      }

      .icon {
        padding: 0 3px;
        width: 17px;
        height: 17px;
        background-image: url(/assets/img/alarm.svg);
        background-repeat: no-repeat;
        background-position: left top;
        transition: 0.3s;
      }

      .text {
        font-size: 16px;
        margin: 0;
      }

      &:hover {
        .icon {
          background-image: url(/assets/img/alarm-white.svg);
          background-repeat: no-repeat;
          background-position: left top;
        }
      }
    }

    &.info {
      width: 370px;
      margin: 0 0 24px;

      @include breakpoint(sm) {
        width: 100%;
        padding: 0 16px;
        min-width: calc(100vw - 30px);
      }

      .icon {
        padding: 0 3px;
        width: 16px;
        height: 16px;
        background-image: url(/assets/img/alarm-white.svg);
        background-size: 14px;
      }

      .text {
        font-size: 14px;
        margin: 0;
      }
    }
  }
}
